module.exports = __webpack_public_path__ + "img/popup_tips.9afd059d.png";